import { GET_NOTIFICATIONS } from 'fixtures/actions'
import { NOTIF_SELF, NOTIF } from 'fixtures/api'
import { getAllList, putData } from 'services/cmsService'
import { timestamp } from 'helpers/timestampHelper'

const getAllNotifs = () => {
  return async dispatch => {
    let data = []
    let newData = await getAllList(NOTIF_SELF)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_NOTIFICATIONS,
      payload: data
    })
  }
}

const updateReadNotifs = (id) => {
  return async dispatch => {
    let data = []
    const updateObj = {
      id: id,
      readAt: timestamp(new Date())
    }

    await putData(NOTIF, updateObj)
    let newData = await getAllList(NOTIF_SELF)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_NOTIFICATIONS,
      payload: data
    })
  }
}

const getFilteredNotifs = (filter) => {
  return async dispatch => {
    let data = []
    const { type, period } = filter
    const typeFilter = type !== 'ALL' ? `type=${type}` : ''
    const periodFilter = period !== 'ALL' ? `period=${period}` : ''

    const uri = `${NOTIF_SELF}${typeFilter !== '' || periodFilter !== '' ? `?${typeFilter}${typeFilter !== '' && periodFilter !== '' ? '&' : ''}${periodFilter}` : ''}`

    let newData = await getAllList(uri)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_NOTIFICATIONS,
      payload: data
    })
  }
}

export { getAllNotifs, getFilteredNotifs, updateReadNotifs }
